import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ErrorMessageEnum} from "../../../../shared/enums/error-message.enum";
import {MessageToastService} from "../../../../service/message-toast.service";
import {tap} from "rxjs";
import {ApiResponse} from "../../../../shared/model/response/ApiResponse";
import {AccessService} from "../../../../service/api/access.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    standalone: false
})
export class RegisterComponent implements OnInit {

  form: FormGroup;
  formErrors: Map<string, string> = new Map();

  constructor(
    private accessService: AccessService,
    private messageToastService: MessageToastService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm(): void {
    this.form = new FormGroup({
      "phoneNumber": new FormControl(null, [Validators.required, Validators.pattern(/^\d{9}$/)]),
      "firstname": new FormControl(null, Validators.required),
      "lastname": new FormControl(null, Validators.required),
      "password": new FormControl(null, Validators.required),
      "passwordRe": new FormControl(null, Validators.required),
    });

  }

  onSubmit() {
    if (this.form.invalid) this.displayFrontEndErrors()
    else {
      this.accessService.register(this.form.value)
        .pipe(tap({
            next: (response) => {
              this.formErrors.clear();
              this.form.reset()
              this.messageToastService.success(response.message);
              this.router.navigate(["registrar-sucesso"])
            },
            error: (apiError: ApiResponse<any>) => {
              this.formErrors = apiError?.formErrors ?? new Map()
              this.messageToastService.error(apiError?.message);
            }
          })
        ).subscribe()
    }
  }

  displayFrontEndErrors() {

    this.formErrors.clear();

    if (this.form.get("phoneNumber")?.hasError("required")) {
      this.formErrors.set('phoneNumber', ErrorMessageEnum.requiredField)
    } else if (this.form.get("phoneNumber")?.hasError("pattern")) {
      this.formErrors.set('phoneNumber', ErrorMessageEnum.invalidPhone)
    }
    //firstname
    if (this.form.get("firstname")?.hasError("required")) {
      this.formErrors.set('firstname', ErrorMessageEnum.requiredField)
    }
    //lastname
    if (this.form.get("lastname")?.hasError("required")) {
      this.formErrors.set('lastname', ErrorMessageEnum.requiredField)
    }
    //password
    if (this.form.get("password")?.hasError("required")) {
      this.formErrors.set('password', ErrorMessageEnum.requiredField)
    }
    //passwordRe
    if (this.form.get("passwordRe")?.hasError("required")) {
      this.formErrors.set('passwordRe', ErrorMessageEnum.requiredField)
    }
    //check if passwords match
    if ((this.form.value["password"] && this.form.value["passwordRe"])
      && (this.form.value["password"] !== this.form.value["passwordRe"])) {
      this.formErrors.set('password', ErrorMessageEnum.passwordMismatch)
      this.formErrors.set('passwordRe', ErrorMessageEnum.passwordMismatch)
    }
  }
}
